import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Button from "../../components/Button/Button";
import {
  addSuggestion,
  getQueryViewerUsers,
} from "../../services/StackHolderQueryService";
import { useSnackbar } from "notistack";
import MultiSelect from "../../components/Select/MultiSelect";
import Loader from "../../components/Loader/Loader";

const InternalComments = ({
  query_details,
  suggestions = [],
  user,
  viewHandler,
}) => {
  const [showAddBox, setShowAddBox] = useState(false);
  const [newSuggestion, setNewSuggestion] = useState("");
  const [replyTo, setReplyTo] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [viewerUsers, setViewerUsers] = useState([]);
  const [viewerList, setViewerList] = useState([]);
  const [loader, setLoader] = useState(false);

  const userChangeHandler = (e) => {
    setViewerUsers(e);
  };

  const onUserRemove = (e) => {
    setViewerUsers(e);
  };

  const fetchViewerUsers = async (organization_id) => {
    try {
      setViewerList([]);
      setLoader(true);
      const response = await getQueryViewerUsers(organization_id);
      if (response.status === 200) {
        setViewerList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching viewer users:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchViewerUsers(query_details.organization_id);
  }, [query_details.organization_id]);

  const addSuggestionHandler = async (
    newSuggestion,
    query_id,
    parent_suggestion_id = 0
  ) => {

    const data = {
      suggestion: newSuggestion,
      query_id: query_id,
      attachment: null,
      parent_suggestion_id: parent_suggestion_id,
      viewer_user_ids: viewerUsers.map((u) => u.id),
      session_id: query_details.session_id,
      organization_id: query_details.organization_id,
    };
    try {
      const response = await addSuggestion({ data });
      if (response.status === 200) {
        viewHandler(query_details, "view");
        setNewSuggestion("");
        setReplyTo(null);
        setShowAddBox(false);
        enqueueSnackbar(response.data.message.success, { variant: "success" });
      }
    } catch (error) {
      console.error(error);
    } finally {
      // setLoader(false);
    }
  };

  return (
    <div
      className="mt-4 p-4 rounded-4 shadow-sm border"
      style={{ backgroundColor: "var(--color-surface-muted)" }}
    >
      <h5
        className="mb-4 fw-semibold d-flex align-items-center"
        style={{ color: "var(--color-primary-text)" }}
      >
        <i className="fa-solid fa-comments me-2"></i> Internal Comments
      </h5>

      {/* Suggestions List */}
      {suggestions.length > 0 ? (
        <ul className="list-unstyled mb-4">
          {suggestions.map((s, idx) => {
            const isCurrentUser = s.user?.id === user?.id;
            const isReplying = replyTo === s.id;

            return (
              <li
                key={s.id || idx}
                className="p-3 mb-3 rounded-3 shadow-sm"
                style={{
                  backgroundColor: isCurrentUser ? "var(--color-primary-soft)" : "var(--color-surface)",
                  border: "1px solid var(--color-border)",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <strong
                    className="fw-semibold"
                    style={{ color: isCurrentUser ? "var(--color-primary-hover)" : "var(--color-text)" }}
                  >
                    {s.user?.name || "Anonymous"}
                  </strong>
                  <small
                    style={{ color: isCurrentUser ? "var(--color-primary)" : "var(--color-text-subtle)" }}
                  >
                    {new Date(s.created_at).toLocaleString()}
                  </small>
                </div>

                <p className="mb-2 text-secondary">{s.suggestion}</p>

                {/* Reply Button
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="py-0 px-2"
                  onClick={() => setReplyTo(isReplying ? null : s.id)}
                >
                  <i className="fa-solid fa-reply me-1"></i>
                  {isReplying ? "Cancel" : "Reply"}
                </Button> */}

                {/* Reply Box */}
                {isReplying && (
                  <div className="mt-3">
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder={`Reply to ${
                        s.user?.name || "this comment"
                      }...`}
                      value={newSuggestion}
                      onChange={(e) => setNewSuggestion(e.target.value)}
                      className="shadow-sm"
                      style={{
                        borderColor: "var(--color-primary-border)",
                        backgroundColor: "var(--color-surface)",
                      }}
                    />
                    {/* <div className="mt-2 text-end">
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() =>
                          addSuggestionHandler(
                            newSuggestion,
                            query_details.id,
                            s.id
                          )
                        }
                        disabled={!newSuggestion.trim()}
                      >
                        <i className="fa-solid fa-paper-plane me-1"></i> Send
                        Reply
                      </Button>
                    </div>*/}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        <>
          {!showAddBox && (
            <div className="text-center mb-3">
              <Button
                variant="outline-primary"
                onClick={() => setShowAddBox(true)}
              >
                <i className="fa-solid fa-plus me-2"></i> Add Suggestion
              </Button>
            </div>
          )}
        </>
      )}

      {/* Add New Suggestion Box (if no suggestion or triggered manually) */}
      {(showAddBox || suggestions.length > 0) && !replyTo && (
        <div className="border-top pt-3">
          {loader ? (
            <Loader />
          ) : (
            <div className="col-md-12 mb-3">
              <MultiSelect
                name="viewer_users"
                options={viewerList}
                id={"user_ids"}
                onRemove={(e) => onUserRemove(e)}
                onChangeHandler={(e) => userChangeHandler(e)}
                displayValue="name"
                placeholder="Select Viewer Users"
                selectedValues={viewerUsers}
                closeOnSelect={false}
              />
            </div>
          )}
          <Form.Group controlId="newSuggestion">
            <Form.Control
              as="textarea"
              rows={2}
              placeholder="Write your comment..."
              value={newSuggestion}
              onChange={(e) => setNewSuggestion(e.target.value)}
              className="shadow-sm"
              style={{
                borderColor: "var(--color-primary-border)",
                backgroundColor: "var(--color-surface)",
              }}
            />
          </Form.Group>

          <div className="mt-3 d-flex justify-content-end gap-2">
            <Button
              variant="secondary"
              onClick={() => {
                setShowAddBox(false);
                setNewSuggestion("");
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() =>
                addSuggestionHandler(newSuggestion, query_details.id, 0)
              }
              disabled={!newSuggestion.trim()}
              className="px-4 fw-semibold border-0"
              style={{
                backgroundColor: "var(--color-primary)",
                color: "var(--color-on-primary)",
              }}
            >
              <i className="fa-solid fa-paper-plane me-2"></i> Add Comment
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InternalComments;
